import "./i18nGlobals";






// ts: click toggle for accounts menu (NOTE: < 990px only)
const accountButton = document.querySelector("#parent-accounts > a") as HTMLAnchorElement | null;
if (accountButton) {
  accountButton.addEventListener("click", (e: MouseEvent) => {
	e.preventDefault();
	if (window.innerWidth < 990) {
    const dropdownMenu = (e.target as HTMLElement).closest("#parent-accounts")?.querySelector(".dropdown-menu") as HTMLElement | null;
    dropdownMenu?.classList.toggle('show');
	}
  });
}



// ts: lazy loading images
document.addEventListener('lazybeforeunveil', (event: Event) => {
  const target = event.target as HTMLElement;
  const bg = target.getAttribute('data-bg');
  if (bg) {
    target.style.backgroundImage = `url(${bg})`;
  }
}, {passive: true});



// ts: Canadian shipping notice on donate and giveaway forms
const canadaShippingNotice = document.querySelector("div[data-type='canada-shipping-notice']") as HTMLElement | null;
const countryDropdown = document.getElementById("formtools_country") as HTMLSelectElement | null ||
                        document.getElementById("id_country") as HTMLSelectElement | null;

document.addEventListener("DOMContentLoaded", () => {
  if (canadaShippingNotice && countryDropdown) {
    canadaShippingNotice.hidden = true;
    countryDropdown.addEventListener("change", (event: Event) => {
      const target = event.target as HTMLSelectElement;
      canadaShippingNotice.hidden = target.value !== "CA";
    });
  }
});



// ts: language menu on click
const languageSelect = document.querySelector("#parent-languages a.language-select") as HTMLAnchorElement | null;

languageSelect?.addEventListener("click", (event: MouseEvent) => {
  event.preventDefault();
  const submenu = languageSelect.nextElementSibling as HTMLElement | null;
  if (submenu && submenu.classList.contains("dropdown-menu")) {
    submenu.classList.toggle("show");
  }
  event.stopPropagation();
});



